import { render, staticRenderFns } from "./testimoniales_slider.vue?vue&type=template&id=618ec448&scoped=true&"
import script from "./testimoniales_slider.vue?vue&type=script&lang=js&"
export * from "./testimoniales_slider.vue?vue&type=script&lang=js&"
import style0 from "./testimoniales_slider.vue?vue&type=style&index=0&id=618ec448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ec448",
  null
  
)

export default component.exports